import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'

export default {
  name: 'AskForAPNPermission',
  extends: BaseModal,
  methods: {
    agreeForAPN() {
      let permissionData = window.safari.pushNotification.permission(
        'web.com.collectomate.deliveries',
      )
      this.checkRemotePermission(permissionData)
    },

    checkRemotePermission(permissionData) {
      console.log('checkRemotePermission', permissionData)
      if (permissionData.permission === 'default') {
        window.safari.pushNotification.requestPermission(
          'https://pwa.collectomate-preprod.enginearch.com/push',
          'web.com.collectomate.deliveries',
          {},
          this.checkRemotePermission,
        )
      } else if (permissionData.permission === 'denied') {
        localStorage.setItem('apn_permission', 'set')
        console.log(
          '%c apn_permission set as: denied - localhost',
          'color: #e01a66; font-weight: bold;',
        )
        this.close(false)
      } else if (permissionData.permission === 'granted') {
        localStorage.setItem('apn_permission', 'set')
        this.sendDeviceToken(permissionData.deviceToken, 'safari')
      }
    },

    sendDeviceToken(token, type) {
      const params = {
        device: { platform: type, token: token },
      }
      axios({
        method: 'post',
        url: 'devices',
        data: params,
      })
        .then(response => {
          console.log('response', response)
          this.close(false)
        })
        .catch(error => {
          console.error('error sendDeviceToken', error)
          this.close(false)
        })
    },
  },
}
